var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMegaphoneIcon = function SvgMegaphoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2012",
    "data-name": "Ret\\xE2ngulo 2012",
    width: 41.188,
    height: 31.95,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5745",
    "data-name": "Grupo 5745",
    transform: "translate(-517 -690)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5739",
    "data-name": "Grupo 5739",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1976",
    "data-name": "Ret\\xE2ngulo 1976",
    width: 50,
    height: 50,
    transform: "translate(517 686)",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5746",
    "data-name": "Grupo 5746",
    transform: "translate(521 699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5746-2",
    "data-name": "Grupo 5746",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4703",
    "data-name": "Caminho 4703",
    d: "M13.312,9.827H5.1a4.116,4.116,0,0,0-4.1,4.1v4.1a4.116,4.116,0,0,0,4.1,4.1H7.156v6.156a2.052,2.052,0,0,0,4.1,0V22.14h2.052L23.568,28.3V3.671Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4704",
    "data-name": "Caminho 4704",
    d: "M9.2,31.244a3.052,3.052,0,0,1-3.046-2.918v-5.2H5.1A5.131,5.131,0,0,1,0,18.03v-4.1a5.13,5.13,0,0,1,5.1-5.1h7.939L23.053,2.814a1,1,0,0,1,1.515.857V28.3a1,1,0,0,1-1.515.857L13.031,23.14h-.775v5.142a3.045,3.045,0,0,1-2.915,2.959q-.069,0-.138,0M7.156,21.127a1,1,0,0,1,1,1v6.155a1.054,1.054,0,0,0,1.1.961,1.046,1.046,0,0,0,1-1v-6.1a1,1,0,0,1,1-1h2.052a1.006,1.006,0,0,1,.515.142l8.745,5.247V5.438l-8.742,5.246a1,1,0,0,1-.514.143H5.1a3.124,3.124,0,0,0-3.1,3.1v4.095a3.124,3.124,0,0,0,3.1,3.1Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4705",
    "data-name": "Caminho 4705",
    d: "M27.456,15.983a9.191,9.191,0,0,0-3.078-6.874V22.837a9.114,9.114,0,0,0,3.078-6.854",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4706",
    "data-name": "Caminho 4706",
    d: "M32.7,15.983h0a2.058,2.058,0,0,0,2.052,2.052h4.1a2.052,2.052,0,0,0,0-4.1h-4.1A2.058,2.058,0,0,0,32.7,15.983",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4707",
    "data-name": "Caminho 4707",
    d: "M34.751,18.41a2.44,2.44,0,0,1-2.427-2.426v0A2.44,2.44,0,0,1,34.75,13.56h4.1a2.427,2.427,0,0,1,.017,4.85Zm-1.677-2.426a1.687,1.687,0,0,0,1.678,1.676h4.1a1.678,1.678,0,0,0-.016-3.351H34.751a1.688,1.688,0,0,0-1.677,1.674",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4708",
    "data-name": "Caminho 4708",
    d: "M29.806,25.875a1.982,1.982,0,0,0,.367,2.779l.043.032c1.088.8,2.237,1.662,3.324,2.483a2.006,2.006,0,0,0,2.812-.384.256.256,0,0,0,.02-.026c0-.021.021-.021.021-.041a2.006,2.006,0,0,0-.384-2.812l-.026-.02c-1.088-.821-2.237-1.683-3.3-2.483a2.037,2.037,0,0,0-2.849.427l0,0a.071.071,0,0,1-.021.041",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4709",
    "data-name": "Caminho 4709",
    d: "M34.745,31.95a2.362,2.362,0,0,1-1.431-.482c-1.085-.821-2.233-1.682-3.32-2.481a2.377,2.377,0,0,1-.951-1.6,2.341,2.341,0,0,1,.466-1.743h0a2.423,2.423,0,0,1,3.4-.546l3.3,2.486a2.393,2.393,0,0,1,.56,3.251v.04l-.1.111a2.41,2.41,0,0,1-1.923.961m-4.659-5.822a1.6,1.6,0,0,0,.316,2.227c1.127.83,2.276,1.693,3.364,2.515A1.636,1.636,0,0,0,36,30.629V30.6l.1-.108a1.636,1.636,0,0,0-.311-2.287l-3.326-2.5a1.664,1.664,0,0,0-2.267.279l0,.018Zm-.281-.254.026.02-.3-.272.277.253Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4710",
    "data-name": "Caminho 4710",
    d: "M36.414,1.229c0-.021-.021-.021-.021-.041A2.012,2.012,0,0,0,33.579.764l-.018.014c-1.088.821-2.257,1.683-3.324,2.5a2.009,2.009,0,0,0-.406,2.811l.016.021c0,.021.021.021.021.041a2.008,2.008,0,0,0,2.809.427l.023-.017c1.088-.8,2.237-1.683,3.324-2.5a2.04,2.04,0,0,0,.39-2.832",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4711",
    "data-name": "Caminho 4711",
    d: "M31.489,7.344a2.331,2.331,0,0,1-.362-.027,2.368,2.368,0,0,1-1.561-.944L29.48,6.24a2.381,2.381,0,0,1,.532-3.262c.657-.5,1.354-1.024,2.048-1.543L33.336.479a2.394,2.394,0,0,1,3.359.486l.086.133a2.431,2.431,0,0,1-.527,3.26l-1.131.854c-.737.558-1.483,1.123-2.2,1.651a2.4,2.4,0,0,1-1.433.481M30.234,6.011a1.633,1.633,0,0,0,2.22.265c.74-.544,1.482-1.106,2.216-1.662L35.8,3.761a1.673,1.673,0,0,0,.315-2.309l-.086-.124A1.641,1.641,0,0,0,33.8,1.066l-1.292.97c-.691.517-1.387,1.037-2.045,1.54a1.634,1.634,0,0,0-.333,2.288Z",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMegaphoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/megaphone-icon.2734187f.svg";
export { ForwardRef as ReactComponent };